import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { ConsentOptionCode } from '../enums/common/ConsentOptionCode.js';
export class ConsentPreferences extends BaseMessage {
    entitlementId;
    consentOptionCode;
    consentEffectiveTimestamp;
}
__decorate([
    Field.number({
        required: true,
        maximum: 99999,
        description: 'This refers to the Unique Identifier of an Entitlement.',
        numberType: 'integer',
    }),
    __metadata("design:type", Number)
], ConsentPreferences.prototype, "entitlementId", void 0);
__decorate([
    Field.enum({
        enum: ConsentOptionCode,
        required: true,
        description: 'This refers to the code that represents the Option selected by the Party in relation to an Entitlement.',
    }),
    __metadata("design:type", String)
], ConsentPreferences.prototype, "consentOptionCode", void 0);
__decorate([
    Field.string({
        format: 'date-time',
        example: '2022-01-01T12:00:00Z',
        required: true,
        description: "The date and time upon which the Party's Consent option against the Entitlement becomes Effective.",
    }),
    __metadata("design:type", String)
], ConsentPreferences.prototype, "consentEffectiveTimestamp", void 0);
//# sourceMappingURL=ConsentPreferences.js.map